const KEY = 'kepp_consent';
const VERSION = 1;
const GTM_ID = process.env.REACT_APP_GTM_ID;
const MAX_AGE_MS = 365 * 24 * 60 * 60 * 1000;

const GA_COOKIE = /^(_ga|_ga_.+|_gid|_gat.*|_gcl_.+)$/;

export const deleteGaCookies = () => {
  const parts = window.location.hostname.split('.');
  const domains = [''];
  for (let i = 0; i < parts.length - 1; i++) {
    const d = parts.slice(i).join('.');
    domains.push(`; domain=${d}`, `; domain=.${d}`);
  }
  document.cookie.split(';').forEach((raw) => {
    const name = raw.split('=')[0].trim();
    if (!GA_COOKIE.test(name)) return;
    domains.forEach((d) => {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${d}`;
    });
  });
};

export const getConsent = () => {
  try {
    const c = JSON.parse(localStorage.getItem(KEY));
    if (!c || c.version !== VERSION) return null;
    if (Date.now() - new Date(c.at).getTime() > MAX_AGE_MS) {
      localStorage.removeItem(KEY);
      deleteGaCookies();
      return null;
    }
    return c;
  } catch {
    return null;
  }
};

let gtmLoaded = false;
const loadGtm = () => {
  if (gtmLoaded || !GTM_ID) return;
  gtmLoaded = true;
  window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(s);
};

export const applyConsent = (c) => {
  if (!c || typeof window.gtag !== 'function') return;
  const v = (on) => (on ? 'granted' : 'denied');
  window.gtag('consent', 'update', {
    analytics_storage: v(c.analytics),
    ad_storage: v(c.marketing),
    ad_user_data: v(c.marketing),
    ad_personalization: v(c.marketing),
  });
  if (!c.analytics) deleteGaCookies();
  if (c.analytics || c.marketing) loadGtm();
};

export const saveConsent = ({ analytics, marketing }) => {
  const c = { version: VERSION, analytics, marketing, at: new Date().toISOString() };
  localStorage.setItem(KEY, JSON.stringify(c));
  applyConsent(c);
  return c;
};

export const trackEvent = (event, params = {}) => {
  if (!getConsent()?.analytics) return;
  window.dataLayer.push({ event, ...params });
};

applyConsent(getConsent());

export const OPEN_SETTINGS_EVENT = 'kepp:open-cookie-settings';
export const openCookieSettings = () => window.dispatchEvent(new Event(OPEN_SETTINGS_EVENT));
